export const PLAN = 'Plan';
//# sourceMappingURL=plan.js.map